module.exports = __webpack_public_path__ + "static/media/FCMH-Raster-06.cb523eea.svg";